<template>
  <div class="container">
    <section class="intro-single">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-8">
            <div class="title-single-box"><h1 class="title-single">Our
              Research</h1><span
              class="color-text-a">LASR Lab - Vanderbilt University Medical Center</span></div>
          </div>
          <div class="col-md-12 col-lg-4">
            <nav aria-label="breadcrumb" class="breadcrumb-box d-flex justify-content-lg-end">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/"
                                               class="router-link-active">Home</a></li>
                <li aria-current="page" class="breadcrumb-item active">
                  Research
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <section class="section-research">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-t1">
            <div class="row" >
              <div class="col-md-12" v-show="!show">
                <div class="alert alert-warning">
                  If you are a study participant or are interested in participating, please don’t
                  proceed to this page. Current or future participants should NOT read this page,
                  because the information in it could contaminate our results. If you are a study
                  participant, please return to the home page and use the links on the right for study
                  info.
                </div>
                <button class="btn btn-primary" @click="show = true">Show Research
                </button>
              </div>
              <div class="col-md-12" v-show="show"><p>The goal of our lab is to progress toward a better
                  understanding of autism, which affects 1 in 54 children in the U.S. While the experiences
                  of individuals on the autism spectrum vary widely, it is defined by social difficulties
                  and repetitive behaviors that impact the life of the individual and their loved ones.
                  We endeavor to understand how these core features of autism are rooted in brain structure
                  and its responses to sensory stimuli.</p>
                <p>Through our five senses, the brain is bombarded with information from the external world,
                    and has the monumental task of filtering and evaluating the significance of all this
                    information.</p>
                <p>We also have additional senses that tell the brain about our internal world-- the state
                    of our bodies in terms of position, health and safety. Our sense of interoception—the
                    information reaching our brain about how fast we are breathing, how fast our hearts are
                    beating, and what our digestive organs are doing—signals our emotional state. This
                    information must be continuously integrated with external sensory information to sustain
                     interactions with others that involve emotions.</p>
                <p>We also collaborate closely with other labs on campus that are studying related ideas:</p>
                <p>With the <a href="https://www.woynaroskilab.com/">Woynaroski lab</a>, we are seeking to understand the developmental role of infant
                 sensory processing as it relates to the early emergence of autistic features or traits.</p>
                <p>With the <a href="http://gauthier.psy.vanderbilt.edu/">Gauthier lab</a>, we are using ultra-high-resolution structural imaging of the visual
                 system to understand face processing in autistic individuals, using the 7T scanner at VUIIS.</p>
                <p>With the <a href="https://my.vanderbilt.edu/woodwardlab/">Woodward lab</a>, we are seeking to understand how sensory-related brain regions are
                 connected with one another at rest, and whether this differs in autism.</p>
                <p>With the <a href="https://my.vanderbilt.edu/masi/">Landman lab (MASI)</a>, we are using advanced tools for measuring cortical folding
                  patterns and applying them to relevant brain regions in autistic brains.</p>
                <p>We’re grateful to the families and individuals who volunteer their time to our research
                  studies, as well as to the following sources of funding:</p>
                <p>Our current projects are supported by the National Institute of Mental Health (NIMH),
                   the Nancy Lurie Marks Foundation, and the NCAA/Pat Summitt Award Research Honorarium,
                   awarded posthumously to David Williams II and donated by his wife, Gail Williams.
                   We've also previously received support from the Autism Science Foundation, the
                   Vanderbilt Clinical and Translational Research Center, Autism Speaks, the International
                   Society for Autism Research (INSAR) Innovation in Autism Research Award, the Carrell
                   Family Discovery Grant, awarded by the Nicholas Hobbs Society, and The Landreth Family
                   Discovery GrantThe Marino Autism Research Institute.</p></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-collaborators" v-show="show">
      <div class="title-box-d"><h3 class="title-d">Our Collaborators</h3></div>
      <div class="container">
        <div class="row">
          <div class="col-md-3" v-for="c in collaborators">
            <div class="row">
              <div class="col-md-12">
                <div class="box-small-person"><h4 class="title-"><a

                  :href="c.link">{{c.name}}</a></h4>
                  <div class="color-d"><a
                    :href="c.link">{{c.location}}</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "Research",
    data: function () {
      return {
        show: false,
        collaborators: [{
          name: "Micah Allen",
          link: "https://micahallen.org/",
          location: "Aarhus University"
        }, {
          name: "Rankin McGugin",
          link: "https://www.vanderbilt.edu/psychological_sciences/bio/rankin-mcgugin",
          location: "Vanderbilt University"
        }, {
          name: "Isabel Gauthier",
          link: "https://www.vanderbilt.edu/psychological_sciences/bio/isabel-gauthier",
          location: "Vanderbilt University"
        }, {
          name: "Jeff Krichmar",
          link: "https://cnlm.uci.edu/krichmar/",
          location: "University of California - Irvine"
        }, {
          name: "Bennett Landman",
          link: "https://my.vanderbilt.edu/masi/people/bennett-landman-ph-d/",
          location: "Vanderbilt University"
        }, {
          name: "Nick Puts",
          link: "https://sites.google.com/site/nputs1984/",
          location: "King's College London"
        }, {
          name: "Susan White",
          link: "https://psychology.ua.edu/people/susan-white/",
          location: "University of Alabama"
        }, {
          name: "Kristina Lopez",
          link: "https://socialwork.asu.edu/content/kristina-lopez",
          location: "Arizona State University"
        }, {
          name: "David Moore",
          link: "https://www.ljmu.ac.uk/about-us/staff-profiles/faculty-of-health/school-of-psychology/david-moore",
          location: "Liverpool John Moores University"
        }, {
          name: "Mark Wallace",
          link: "https://vkc.mc.vanderbilt.edu/people/wallace-mark/",
          location: "Vanderbilt University Medical Center"
        }, {
          name: "Tiffany Woynaroski",
          link: "https://vkc.mc.vanderbilt.edu/people/woynaroski-tiffany",
          location: "Vanderbilt University Medical Center"
        }, {
          name: "Sohee Park",
          link: "http://parklab.vanderbilt.edu/?page_id=227",
          location: "Vanderbilt University Medical Center"
        }, {
          name: "Neil Woodward",
          link: "https://www.vumc.org/early-psychosis-program/person/neil-woodward-phd",
          location: "Vanderbilt University Medical Center"
        }, {
          name: "Grace Baranek",
          link: "http://www.med.unc.edu/ahs/ocsci/sep",
          location: "University of North Carolina"
        }]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Research.vue